export const DATE_STOP_CHANGE_REQUEST = 25;
export const DATE_START_CHANGE_REQUEST = 1;
